<div class="container">
  <div class="container-left">
    <div class="screen-user">
      <div class="screen__label screen__label--user">User:</div>
      <div class="screen__value screen__value--user">{{ (authState$ | async).user }}</div>
    </div>
    <div class="screen-custid" (click)="authService.changeCustomerDialog$.next(true)">
      <div class="screen__label screen__label--custid">Customer:</div>
      <div class="screen__value screen__value--custid">{{ (authState$ | async).custid }}</div>
    </div>
    <div class="screen-facility" (click)="authService.changeFacilityDialog$.next(true)">
      <div class="screen__label screen__label--facility">Facility:</div>
      <div class="screen__value screen__value--facility">{{ (authState$ | async).facility }}</div>
    </div>
  </div>
  <div class="container-center">
    <div class="screen-title">
      <div class="screen__value screen__value--title">{{ screenTitle$ | async }}</div>
    </div>
  </div>
  <div class="container-right">
    <app-loading-indicator></app-loading-indicator>
  </div>
</div>

<app-change-customer-dialog></app-change-customer-dialog>

<app-change-facility-dialog></app-change-facility-dialog>

<app-session-timeout-dialog></app-session-timeout-dialog>

<app-modal-dialog></app-modal-dialog>

<app-modal-loading-indicator></app-modal-loading-indicator>
